/**
 * RESPONSIBILITY: one dated entry in an event's list of times.
 *
 * Covers both shapes a church page uses: the bare list of dates a recurring evening
 * falls on, and the service times of a season where each one has its own words and its
 * own booking link. They are the same row with the optional parts left empty.
 */
import { Row, Text, DateField, Link } from '@framework/core/decorators';

@Row()
export class ScheduleRow {
  @DateField({ label: 'When', time: true })
  when!: string;

  @Text({ label: 'What', maxLength: 300, description: 'e.g. Good Friday service. Empty shows the date alone.' })
  label!: string;

  @Text({ label: 'Note', maxLength: 300, description: 'e.g. Childcare provided.' })
  note!: string;

  @Link({ label: 'Booking link', description: 'Optional. Shown as a link on this line.' })
  href!: string;

  @Text({
    label: 'Booking link text', maxLength: 120, default: 'Book',
    description: 'The word on that link. Only used when there is a link.',
  })
  hrefLabel!: string;
}
